module.exports = __webpack_public_path__ + "static/03-08a48630db6be54462ceb5e378a2cc4b.jpg";